export interface ICarouselSlide {
  id: number | string;
  title: string;
  header?: string;
  actionTitle?: string;
  subtitle?: string;
  link?: string;
  description?: string;
  sourceSet: string[];
}
